import { Injectable } from '@angular/core';
import { ServiceService } from './service.service';

@Injectable({
  providedIn: 'root'
})
export class PqrsFacultadesService {

  constructor(private servi: ServiceService) { }

  public getServe() { return this.servi.server; }

  public getPQRS(id) {
    return this.servi.get('PQRSFacultades/GetPQRS');
  }

  public GetPQRShistorial(id) {
    return this.servi.get('PQRSFacultades/GetPQRShistorial');
  }

  public AsignarPQRS(formintegrantes) {
    return this.servi.post(`PQRSFacultades/PostAsignar/`, formintegrantes);
  }

  // public rechazarSolicitud(data) {
  //   return this.servi.post(`PQRSFacultades/RechazarSolicitud`, data);
  // }

  public devolverSolicitud(data) {
    return this.servi.post(`PQRSFacultades/DevolverSolicitud`, data);
  }

  public responderSolicitud(data) {
    const formData = new FormData();
    for ( const nombre in data ) { 
      if (data[nombre]) {
          formData.append(nombre, data[nombre]);
      } 
    }
    return this.servi.postFile(`PQRSFacultades/ResponderSolicitud`, formData);
  }
}
